import enUS from '@/locales/en-US.json'
import {
  flashSales as enUSflashSales,
  booking as enUSbooking,
  slots as enUsslots,
  pointConfig as enUSpointConfig,
} from '@/locales/en-US/index'
// Import translation files
import viVN from '@/locales/vi-VN.json'
import {
  flashSales as viVNflashSales,
  booking as viVNbooking,
  slots as viVNslots,
  pointConfig as viVNpointConfig,
} from '@/locales/vi-VN/index'
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

export const default_lng = 'vi-VN'
export const languages = {
  'vi-VN': 'Tiếng Việt',
  'en-US': 'English',
}

export const resources = {
  'vi-VN': {
    translation: {
      ...viVN,
      flashSales: viVNflashSales,
      bookings: viVNbooking,
      slots: viVNslots,
      pointConfig: viVNpointConfig,
    },
  },
  'en-US': {
    translation: {
      ...enUS,
      flashSales: enUSflashSales,
      bookings: enUSbooking,
      slots: enUsslots,
      pointConfig: enUSpointConfig,
    },
  },
} as const

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: default_lng,
    fallbackLng: default_lng,
    debug: false, // Set to true for development debugging

    interpolation: {
      escapeValue: false, // React already does escaping
    },

    detection: {
      order: ['localStorage', 'cookie', 'navigator'],
      caches: ['localStorage', 'cookie'],
      lookupLocalStorage: 'i18next-lng',
      lookupCookie: 'i18next-lng',
    },

    // Namespace configuration
    defaultNS: 'translation',
    ns: ['translation', 'slots'],
  })

export default i18n
